import '@knots/shared-frontend' // KEEP IT AT THE TOP

import React from 'react'
import { createRoot } from 'react-dom/client'
import App from './app/App'
import reportWebVitals from './reportWebVitals'
import 'bootstrap/dist/css/bootstrap.min.css'
import '@/assets/css/index.scss'
import 'react-grid-layout/css/styles.css'
import 'react-resizable/css/styles.css'

import { ThemeProvider } from '@/providers/theme'

const container = document.getElementById('root')!
const root = createRoot(container)

root.render(
  <React.StrictMode>
    <ThemeProvider>
      <App />
    </ThemeProvider>
  </React.StrictMode>
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
